'use strict';

$('.cfe-slider-cp-2, .cfe-slider-cp-3, .cfe-slider-cp-5, .clf-slider-cp-3').slick({
    slidesToShow: 1,
    centerMode: false,
    arrows: true,
    swipe: true,
    infinite: true,
    initialSlide: 0,
    swipeToSlide: true,
    dots: true,
    autoplay: false,
    adaptiveHeight: true,
    nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
    prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>'
});

const moveDotsInsideSlider = (slider, destination) => {
    slider.find('.slick-dots').not('.cloned-dots').clone().appendTo(slider.find(destination))
    slider.find(destination).find('.slick-dots').addClass('cloned-dots')
}

const calculateImgHeight = (slider) => {
    var currentImgHeight = slider.find('.slick-current.slick-active img').not('.desktop-img').height();
    if(window.matchMedia("(max-width: 1200px)").matches) {
        slider.find('.slick-arrow').css('height', currentImgHeight)
    }
}

const sliderCP2 = $('.cfe-slider-cp-2'),
    sliderCP3 = $('.cfe-slider-cp-3'),
    sliderCP5 = $('.cfe-slider-cp-5'),
    sliderCLF3 = $('.clf-slider-cp-3');
const destinationCP2 = '.paragraph-text',
    destinationCP3 = '.text-content-3',
    destinationCP5 = '.cfe-component-text-5',
    destination_CLF3_CLF3_items = '.paragraph-text-3',
    destination_CP2_CP2_items_3_4 = ".js-dots-destination";

setTimeout(() => {
    calculateImgHeight(sliderCP2)
    calculateImgHeight(sliderCP3)
    calculateImgHeight(sliderCP5)
}, 500)

$(window).on('resize', function () {
    calculateImgHeight(sliderCP2)
    calculateImgHeight(sliderCP3)
    calculateImgHeight(sliderCP5)
})

// Slider CLF - Collectif Pro 
moveDotsInsideSlider(sliderCLF3, destination_CLF3_CLF3_items)
sliderCLF3.on('afterChange', function(event, slick, currentSlide, nextSlide){ // eslint-disable-line no-unused-vars
    sliderCLF3.find(destination_CLF3_CLF3_items).find('.slick-dots').remove()
    moveDotsInsideSlider(sliderCLF3, destination_CLF3_CLF3_items)
    calculateImgHeight(sliderCLF3)
});

$(document).on('click', '.clf-slider-cp-3 .cloned-dots li', function() {
    var slideIndex = $(this).index();
    sliderCLF3.slick('slickGoTo', parseInt(slideIndex));
});

// Slider 2 - diversite et inclusion
moveDotsInsideSlider(sliderCP2, destinationCP2)
sliderCP2.on('afterChange', function(event, slick, currentSlide, nextSlide){ // eslint-disable-line no-unused-vars
    var self = $(this);
    sliderCP2.find(destinationCP2).find('.slick-dots').remove()
    moveDotsInsideSlider(sliderCP2, destinationCP2)
    calculateImgHeight(sliderCP2)
    if( $('.clf-2, .clf-3').hasClass('slick-current')) {
        self.parents('.collectif-component-2').addClass('arrows-black');
    }else {
        self.parents('.collectif-component-2').removeClass('arrows-black');
    }
});

$(document).on('click', '.cfe-slider-cp-2 .cloned-dots li', function() {
    var slideIndex = $(this).index();
    sliderCP2.slick('slickGoTo', parseInt(slideIndex));
});

// Slider 3 - innovation
moveDotsInsideSlider(sliderCP3, destinationCP3)
sliderCP3.on('afterChange', function(event, slick, currentSlide, nextSlide){ // eslint-disable-line no-unused-vars
    sliderCP3.find(destinationCP3).find('.slick-dots').remove()
    moveDotsInsideSlider(sliderCP3, destinationCP3)
    calculateImgHeight(sliderCP3)
});

$(document).on('click', '.cfe-slider-cp-3 .cloned-dots li', function() {
    var slideIndex = $(this).index();
    sliderCP3.slick('slickGoTo', parseInt(slideIndex));
});

// Slider 5 - we are committed for ever
moveDotsInsideSlider(sliderCP5, destinationCP5)
sliderCP5.on('afterChange', function(event, slick, currentSlide, nextSlide){ // eslint-disable-line no-unused-vars
    sliderCP5.find(destinationCP5).find('.slick-dots').remove()
    moveDotsInsideSlider(sliderCP5, destinationCP5)
    calculateImgHeight(sliderCP5)
});

$(document).on('click', '.cfe-slider-cp-5 .cloned-dots li', function() {
    var slideIndex = $(this).index();
    sliderCP5.slick('slickGoTo', parseInt(slideIndex));
});

// For Item 3 - diversite & inclusion
moveDotsInsideSlider(sliderCP2, destination_CP2_CP2_items_3_4)
sliderCP2.on('afterChange', function(event, slick, currentSlide, nextSlide){ // eslint-disable-line no-unused-vars
    sliderCP2.find(destination_CP2_CP2_items_3_4).find('.slick-dots').remove()
    moveDotsInsideSlider(sliderCP2, destination_CP2_CP2_items_3_4)
});

// For Item 2 & 3 - innovation
moveDotsInsideSlider(sliderCP3, destination_CP2_CP2_items_3_4)
sliderCP3.on('afterChange', function(event, slick, currentSlide, nextSlide){ // eslint-disable-line no-unused-vars
    sliderCP3.find(destination_CP2_CP2_items_3_4).find('.slick-dots').remove()
    moveDotsInsideSlider(sliderCP3, destination_CP2_CP2_items_3_4)
});

$('.cfe-products-carousel').slick({
    slidesToShow: 3,
    centerMode: false,
    arrows: false,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    responsive: [{
        breakpoint: 1024,
        settings: {
            slidesToShow: 3,
            centerMode: false,
            arrows: true,
            swipe: true,
            infinite: false,
            initialSlide: 0,
            swipeToSlide: true,
            autoplay: false,
            dots: false,
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1.3,
            centerMode: false,
            initialSlide: 0,
            arrows: true,
            swipe: true,
            infinite: true,
            dots: false
        }
    }]
});

$('.brand-products-carousel').slick({
    slidesToShow: 4,
    centerMode: false,
    arrows: true,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
    prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>',
    responsive: [{
        breakpoint: 1030,
        settings: {
            slidesToShow: 3,
            centerMode: true,
            initialSlide: 0,
            arrows: false,
            swipe: true,
            infinite: true,
            dots: false
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            initialSlide: 0,
            arrows: false,
            swipe: true,
            infinite: true,
            dots: false
        }
    }]
});

$('.explore-dreamland-carousel').slick({
    slidesToShow: 3,
    centerMode: false,
    arrows: true,
    swipe: true,
    infinite: false,
    initialSlide: 0,
    swipeToSlide: true,
    dots: false,
    autoplay: false,
    nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
    prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>',
    responsive: [{
        breakpoint: 1030,
        settings: {
            slidesToShow: 3,
            centerMode: true,
            initialSlide: 0,
            arrows: false,
            swipe: true,
            infinite: true,
            dots: false
        }
    },
    {
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            centerMode: true,
            initialSlide: 0,
            arrows: false,
            swipe: true,
            infinite: true,
            dots: false
        }
    }]
});

$('.academyComponent-3 .btn-popin, .travelComponent-2 .btn-viewAll').on('click', function () {
    $('.aca-exh-carousel').slick({
        slidesToShow: 1,
        centerMode: false,
        arrows: true,
        swipe: true,
        infinite: false,
        initialSlide: 0,
        swipeToSlide: true,
        dots: false,
        autoplay: false,
        nextArrow: '<button class="next-arrow"><span class="icon-CHEVRON"></span></button>',
        prevArrow: '<button class="prev-arrow"><span class="icon-CHEVRON"></span></button>',
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                arrows: false,
                swipe: true,
                dots: false
            }
        }]
    });
});

$(document).on('click touchstart tap', '.experience-popover-video button.close' , function () {
    var popovervideoWrap1 = $('.experience-popover-video #vimeoWrap1 iframe')[0];
    var popovervideoWrap2 = $('.experience-popover-video #vimeoWrap2 iframe')[0];

    var player1 =  $f(popovervideoWrap1); // eslint-disable-line no-undef
    var player2 =  $f(popovervideoWrap2); // eslint-disable-line no-undef

    player1.api('pause');
    player2.api('pause');

});